var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.719 15.625a.844.844 0 100-1.688.844.844 0 000 1.688z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.719 12.25v-.563A1.969 1.969 0 109.75 9.72",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.793 18.553a.9.9 0 00-.9-.9H6a1.35 1.35 0 01-1.35-1.35V6.25c0-.746.604-1.35 1.35-1.35h12c.746 0 1.35.604 1.35 1.35v10.053a1.35 1.35 0 01-1.35 1.35h-4.429a.9.9 0 00-.412.1l-5.366 2.77v-1.97z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })));
}
export default SvgFaqIcon;